import React from "react";

import isIntuit from "Intuit/isIntuit";
import { resetFilter } from "QuotePage/Actions";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import Button from "Common/Button";
import { Card } from "Common/Card/";
import { Col, Row } from "Common/Grid";

const NoPlansCard = ({ onClick }) => (
  <Card>
    <div className="NoPlansCard__header_margin">
      <TitleSmall mt={0} mb={0}>
        Sorry, we could not find plans in your area that match the criteria specified.
      </TitleSmall>
    </div>
    <div className="NoPlansCard__content_margin">Please adjust the filters.</div>
    <Row>
      <Col md={3}>
        <Button color="blue" size="medium" fullWidth onClick={onClick}>
          Reset Filters
        </Button>
      </Col>
    </Row>
  </Card>
);

function mapDispatchToProps(dispatch) {
  return {
    onClick: () => {
      AnalyticsTracking.trackEvent("cta_clicked", {
        location: "no_plans_card",
        action: "reset_filter",
      });

      dispatch(resetFilter());
    },
  };
}

export default connect(null, mapDispatchToProps)(NoPlansCard);
